import React from "react";
import QuestionItemInfo from "./QuestionItemInfo";
import questionsData from "../assets/json/patient_narrative_questions_data.json";
import { isRequiredField } from "../utils/patientNarrativeRequiredFields";

/**
 * Label + info note for one Patient Narrative wizard question, with the red
 * asterisk CSR uses for mandatory fields (`questions-content__required-
 * asterisk`, see QuestionItem.js).
 *
 * Whether a question is mandatory is looked up from the section's required
 * fields rather than passed in per call site, so a label and the Next button
 * can never disagree about it.
 *
 * `questions` is the label map the page fetched from
 * GET /patient-narratives/questions (see usePatientNarrativeQuestions); the
 * info note still comes from the local JSON.
 */
const PatientNarrativeQuestionLabel = ({ section, field, questions }) => (
  <div className={"questions-content__label"}>
    <span className={"questions-content__label-text"}>
      {questions[field]}
      {isRequiredField(section, field) && (
        <span className={"questions-content__required-asterisk"}> *</span>
      )}
    </span>
    <QuestionItemInfo
      questionName={field}
      notes={questionsData.questionsInfo}
    />
  </div>
);

export default PatientNarrativeQuestionLabel;
